// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1FpLn","footer":"ModalUpdate_footer__1N3QA"};